<template>
	<div class="row justify-content-center">
		<template v-if="feedbackCarregando">
			<component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
		</template>
		<template v-else>
			<template>
				<div v-if="feedbacks.length <= 0">
					<ul class="list-group list-group-flush">
                        <li class="list-group-item">Essa aula ainda não foi avaliada pelo aluno.</li>
                    </ul>
				</div>
				<div class="card" style="width: 30em;" v-else>
					<div class="card-body" v-for="feedback in feedbacks" :key="feedback.index">
						<template>
							<div class="d-flex">
								<h3 v-for="nota in feedback.nota" :key="nota.index" class="card-title mr-3">
									<i class="fa fa-star fa-lg text-primary mb-3"></i>
								</h3>
								<div class="d-flex">
									<h3 v-for="nota in ((feedback.nota - 5) * -1)" :key="nota.index"
										class="card-title mr-3">
										<i class="fa fa-star-o fa-lg text-primary mb-3"></i>
									</h3>
								</div>
							</div>
							<div>
								<div class="mb-3">
									<h5 class="text-primary">Autor:</h5>
									<p class="card-text">{{ feedback.aluno.nome }}</p>
								</div>
								<div>
									<h5 class="text-primary">Descrição:</h5>
									<p class="card-text">{{ feedback.descricao }}</p>
								</div>
							</div>
						</template>
					</div>
				</div>
			</template>
		</template>
	</div>
</template>

<script>

import AgendamentoController from './AgendamentoController'
import * as spinners from 'epic-spinners'

export default {
  name: 'FeedbackTab',
  components: {
    ...spinners,
  },
  data () {
    return {
      feedbacks: [],
      feedbackCarregando: false,
    }
  },
  props: {
    aulaId: Number
  },
  methods: {
    loadData () {
      this.loadFeedback(this.aulaId)
    },

    loadFeedback (aula) {
      this.feedbackCarregando = true

      AgendamentoController.loadFeedback(aula, (response) => {
        if (response.sucesso === true) {
          this.feedbacks = response.dados

          this.feedbackCarregando = false
        } else {
          console.log('Deu ruim')

          this.avaliacoesCarregando = false
        }
      })
    }
  },
  mounted () {
    this.loadData()
  }

}
</script>
